import { orchestrator } from 'satcheljs';
import { onModuleClick } from 'owa-workloads';
import { Module } from 'owa-workloads-module';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { setShowPstTasksMutator } from '../mutators/setShowPstTasksMutator';
import shouldShowPstTasks from '../selectors/shouldShowPstTasks';
import { setSelectedApp } from 'owa-appbar-state';
import { M365AppId } from 'owa-m365-acquisitions/lib/data/M365AppId';

/**
 * Handle PST Tasks module clicks:
 * 1. Show PST Tasks view when clicking Tasks in a PST account
 * 2. Hide PST Tasks view when clicking Calendar, People, or other non-Mail/Tasks modules
 */
orchestrator(onModuleClick, actionMessage => {
    const { module, mailboxInfo } = actionMessage;

    // First, handle hiding PST Tasks when switching to other modules
    if (shouldShowPstTasks() && module !== Module.Tasks && module !== Module.Mail) {
        // User is clicking Calendar, People, etc. - hide PST Tasks
        setShowPstTasksMutator(false);
        return;
    }

    // Now handle showing PST Tasks when clicking Tasks in a PST account
    if (module !== Module.Tasks) {
        return;
    }

    if (!isFeatureEnabled('mon-pst-task')) {
        return;
    }

    // Use current global mailbox if not provided (handles account switches)
    const currentMailboxInfo = mailboxInfo || getGlobalSettingsAccountMailboxInfo();

    // Check if this is a PST account
    if (!currentMailboxInfo || !isLocalDataBackedMailboxInfo(currentMailboxInfo)) {
        return;
    }

    // Change the module to Mail to prevent Tasks module state
    // This ensures PST accounts always stay in Mail module
    actionMessage.module = Module.Mail;

    // Always show PST Tasks immediately (handles account switches)
    setShowPstTasksMutator(true);

    // Set the AppBar selection to Tasks
    setSelectedApp(M365AppId.Tasks);

    // Provide an empty action to prevent default module switch behavior
    actionMessage.activeModuleAction = () => {
        // State already updated by direct mutator call above
    };
});
